import React, { useEffect, useState } from "react";
import { ASSETS, api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Gallery() {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    api.get("/gallery")
      .then((r) => setPhotos((r.data || []).sort((a, b) => (a.position || 0) - (b.position || 0))))
      .catch(() => setPhotos([]));
  }, []);

  const list = photos.length > 0 ? photos : [
    { url: ASSETS.heroInterior, alt: "Salle dressée du Globo Dancing" },
    { url: ASSETS.facade, alt: "Façade Globo Dancing à Trappes" },
    { url: ASSETS.diningRoom, alt: "Salle de restauration et fauteuils" },
    { url: ASSETS.tableDetail, alt: "Détail dressage de table" },
    { url: ASSETS.bar, alt: "Espace bar et soirées" },
  ];

  return (
    <div data-testid="gallery-page">
      <SEO title="Galerie" description="Découvrez en images le restaurant Globo Dancing à Trappes : la salle, la façade, l'ambiance des soirées portugaises et les plats traditionnels." path="/galerie"/>
      <section className="pt-32 pb-12 azulejo-bg">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="eyebrow">Memórias do Globo</div>
          <h1 className="text-5xl md:text-7xl mt-4 max-w-3xl leading-[0.95]">
            La <em className="italic text-[#C04E38]">vie</em> au Globo
          </h1>
          <p className="text-[#5C5A56] text-lg mt-5 max-w-2xl">
            Quelques instantanés de notre maison : les plats qui mijotent, les
            tablées qui rient, les soirées qui chantent.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          {list.length === 0 ? (
            <p className="text-center text-[#5C5A56]" data-testid="gallery-empty">Aucune photo pour l'instant.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {list.map((p, i) => (
                <div key={p.id || i} className="aspect-[4/3] overflow-hidden rounded-2xl group" data-testid={`gallery-item-${i}`}>
                  <img src={p.url} alt={p.alt || "Globo Dancing"} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"/>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
